import {css, view} from '@sail/ui/deprecated';
import {MetaEventStyle} from '@stripe-internal/conversations-client';
import {useMemo} from 'react';
import {ChatRowContainer} from './ChatRowContainer';
import {
  useNewUniversalHelpDesign,
  useUniversalHelpDotComDesign,
} from '../../FeatureFlagsProvider';

export type Props = {
  style?: MetaEventStyle;
  children: React.ReactNode;
};

export const MetaRow = ({style, children}: Props) => {
  const useNewDesign = useNewUniversalHelpDesign();
  const useDotComDesign = useUniversalHelpDotComDesign();

  const styles = useMemo(() => {
    if (useNewDesign) {
      if (style === 'body') {
        return css({
          textAlign: css.value('left'),
          font: 'body',
          marginBottom: 'medium',
        });
      } else {
        return css({
          textAlign: css.value('center'),
          font: 'caption',
          color: 'secondary',
        });
      }
    }

    if (useDotComDesign) {
      return css({
        textAlign: css.value('center'),
        font: 'caption',
        color: 'secondary',
      });
    }

    return css({
      textAlign: css.value('center'),
      font: 'caption',
      fontStyle: css.value('italic'),
      color: 'secondary',
    });
  }, [useNewDesign, useDotComDesign, style]);

  return (
    <view.div data-testid="meta-row">
      <ChatRowContainer position="center">
        <view.div uses={[styles]}>{children}</view.div>
      </ChatRowContainer>
    </view.div>
  );
};
